import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import {
  ProStudioContext,
  ProStudioEvents,
  SelectedSolution,
} from '../prostudio.xstate.types';

export const changeBotType = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<SelectedSolution | void> => {
  if (event.type !== 'setBotType') {
    return;
  }

  const { botName, customerId, project, solutions, selectedBot } = ctx;
  const { botType } = event;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!botName) {
    throwErrorWithId('Bot name is required');
    return;
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
    return;
  }

  const botId = `${customerId}.${botName}`;

  if (!botId) {
    throwErrorWithId('Bot ID is required');
  }

  if (!botType) {
    throwErrorWithId('Bot type is required');
    return;
  }

  const patchBotResponse = await urqlGql.patchBotById({
    botId,
    botType,
    projectId,
  });

  checkForErrors(patchBotResponse);

  const data = patchBotResponse.data?.patchBotById?.data;

  if (!data?.id) {
    throwErrorWithId('Updated bot ID is required');
    return;
  }

  console.log('PATCH_BOT_RESPONSE', data);

  const displayName =
    solutions?.find((solution) => solution.botSolutionId === data.id)
      ?.displayName ||
    selectedBot?.displayName ||
    '';

  return {
    ...data,
    displayName,
    uniqueId:
      solutions?.find((solution) => solution.botSolutionId === data.id)?.id ||
      '',
  };
};
